import GravityBulkAdapter from 'teacher-ui-client/adapters/gravity/bulk-adapter'
import config from 'teacher-ui-client/config/environment'
import { service } from '@ember/service'
import { assert } from '@ember/debug'
import { join, joinQueryParams } from 'teacher-ui-client/utils/uri'
import type SessionService from 'teacher-ui-client/services/session'
import type { Snapshot } from '@ember-data/legacy-compat/legacy-network-handler/snapshot'

export default class TeacherAdapter extends GravityBulkAdapter {
  @service session!: SessionService

  addIncludeToUrl(url: string, include?: string) {
    return joinQueryParams(url, { include }).href
  }

  urlForCreateRecord(modelName: string, snapshot: Snapshot<unknown>) {
    const url = super.urlForCreateRecord(modelName, snapshot)

    const include = snapshot.adapterOptions?.include
    assert('teacher includes if provided must be string', typeof include === 'string' || typeof include === 'undefined')

    return include ? this.addIncludeToUrl(url, include) : url
  }

  urlForFindAll() {
    const { currentSchool } = this.session

    assert('currentSchool.id missing', currentSchool?.id)

    return join(config.gravityV3Url, 'schools', currentSchool.id, 'teachers').toString()
  }

  urlForQuery() {
    const { currentSchool } = this.session

    assert('currentSchool.id missing', currentSchool?.id)

    return join(config.gravityV3Url, 'schools', currentSchool.id, 'teachers').toString()
  }
}
